import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {AccountUserInviteStatusKind} from '../enum/account.user.invite.status.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AccountEntity} from './account.entity';

@EntityTable('account_user_invite', '325e70ce-8506-48a7-9274-5714f3cc2441')
export class AccountUserInviteEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, AccountEntity, false, false, FieldRelationKind.BELONGS_TO, 'account')
    public accountId: string;

    @Column(FieldTypeKind.STRING)
    public email: string;

    @Column(FieldTypeKind.LONG)
    public status: AccountUserInviteStatusKind;
}
